// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2289":"a11e05625309ed51","9201":"a1507808adf5a159"}[chunkId] + ".js";
};